import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "container mx-auto p-2" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h1", { class: "text-3xl font-bold" }, "ユーザー一覧", -1);
const _hoisted_3 = { class: "py-4 text-left text-lg" };
const _hoisted_4 = { class: "w-full table-fixed" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("thead", { class: "bg-lime-100" }, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "border border-slate-500 px-6 py-3"
        }, "名前"),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "border border-slate-500 px-6 py-3"
        }, " 電話番号 ")
    ])
], -1);
const _hoisted_6 = { class: "border border-slate-500 px-6 py-3" };
const _hoisted_7 = { class: "border border-slate-500 px-6 py-3" };
const _hoisted_8 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FunnelIcon = _resolveComponent("FunnelIcon");
    const _component_router_link = _resolveComponent("router-link");
    const _component_EyeIcon = _resolveComponent("EyeIcon");
    const _component_EyeSlashIcon = _resolveComponent("EyeSlashIcon");
    const _component_LinkButton = _resolveComponent("LinkButton");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, k) => {
                        return (_openBlock(), _createElementBlock("tr", { key: k }, [
                            _createElementVNode("td", _hoisted_6, [
                                _createVNode(_component_router_link, {
                                    to: {
                                        path: _ctx.localizedUrl(`/${_ctx.removeSymbols(_ctx.groupId)}/photos`),
                                        query: { searchText: `uid:${user.id}` },
                                    }
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_FunnelIcon, { class: "mb-1 mr-3 inline h-6 w-6" }),
                                        _createTextVNode(" " + _toDisplayString(user.getRealName()), 1)
                                    ]),
                                    _: 2
                                }, 1032, ["to"])
                            ]),
                            _createElementVNode("td", _hoisted_7, [
                                _createElementVNode("div", {
                                    onClick: ($event) => {
                                        _ctx.updateVisibleUid(user.id);
                                        _ctx.recordLog(user.id);
                                    },
                                    class: "cursor-pointer"
                                }, [
                                    (_ctx.visibleUid !== user.id)
                                        ? (_openBlock(), _createBlock(_component_EyeIcon, {
                                            key: 0,
                                            class: "mb-1 mr-3 inline h-6 w-6"
                                        }))
                                        : (_openBlock(), _createBlock(_component_EyeSlashIcon, {
                                            key: 1,
                                            class: "mb-1 mr-3 inline h-6 w-6"
                                        })),
                                    _createTextVNode(" " + _toDisplayString(_ctx.visibleUid === user.id ? user.getPhoneNumber() : "*****"), 1)
                                ], 8, _hoisted_8)
                            ])
                        ]));
                    }), 128))
                ])
            ])
        ]),
        _createElementVNode("div", null, [
            _createVNode(_component_LinkButton, {
                path: "photos",
                name: "写真一覧へ"
            })
        ])
    ]));
}
